import { createRouter, createWebHistory } from 'vue-router'
import Map from '../views/Map.vue'
import MapView from '../views/MapView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Map
  },
  {
    path: '/detail/:cityCode?',
    name: 'MapView',
    component: MapView,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 